<template>
  <v-container v-if="currentTemplate && currentTemplateSnippet">
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbTemplateItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar
          :title="currentTemplateSnippet.name"
          :label="$t('labels.newTemplateSnippet')"
          :withLockIcon="!teamCan('template-snippets')"
        >
          <v-button round secondary icon :active="teamCan('template-snippets')" @click.native="createTemplateSnippet()">
            <v2-icon :data="require('@icon/Icon=plus.svg')" color="#fff"></v2-icon
          ></v-button>
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-list-header simple>
          <v-list-header-cell :title="$t('titles.templateSnippetInfos')" />
          <v-list-header-cell
            :link="$t('actions.edit')"
            :disabledLink="!teamCan('template-snippets')"
            :disabledHandler="
              () => {
                $h.showSubscriptionErrorModal(
                  $modal,
                  teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')
                );
              }
            "
            :route="{
              name: 'editTemplateSnippet',
              params: {
                template: currentTemplate.uid,
                uid: currentTemplateSnippet.uid,
              },
            }"
          />
        </v-list-header>
        <ul class="list">
          <v-list-item simple>
            <v-list-cell :title="$t('templateSnippets.name')" />
            <v-list-cell :value="currentTemplateSnippet.name" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('templateSnippets.type')" />
            <v-list-cell :value="$h.templateSnippetsStatus(currentTemplateSnippet.status, 'type')" size="2" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('templateSnippets.default')" />
            <v-list-cell :value="$h.templateSnippetsStatus(currentTemplateSnippet.status, 'default')" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
    <v-row v-if="$h.templateSnippetsStatus(currentTemplateSnippet.status, 'type', false) === 'email'">
      <v-col class="col-12">
        <v-list-header simple>
          <v-list-header-cell
            :title="
              $t('titles.templateSnippetDefaultSubject', {
                lang: $t('lang.' + currentTemplate.locale),
              })
            "
          />
        </v-list-header>
        <ul class="list">
          <v-list-item
            simple
            :key="'defaultSubjectGender-' + genderContent.key"
            v-for="genderContent in $h.getOrderedGenderArray(currentTemplateSnippet.content.subject.default)"
          >
            <v-list-cell :title="$t('gender.' + genderContent.key)" />
            <v-list-cell :value="genderContent.value" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
    <v-row :key="'subject-' + locale" v-for="(localeContent, locale) in filteredCurrentTemplateSnippetSubject">
      <v-col class="col-12">
        <v-list-header simple>
          <v-list-header-cell
            :title="
              $t('titles.templateSnippetLanguageSubject', {
                lang: $t('lang.' + locale, locale),
              })
            "
          />
        </v-list-header>
        <ul class="list">
          <v-list-item
            simple
            :key="'subjectGender-' + genderContent.key"
            v-for="genderContent in $h.getOrderedGenderArray(localeContent)"
          >
            <v-list-cell :title="$t('gender.' + genderContent.key)" />
            <v-list-cell :value="genderContent.value" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-list-header simple>
          <v-list-header-cell
            :title="
              $t('titles.templateSnippetDefaultContent', {
                lang: $t('lang.' + currentTemplate.locale),
              })
            "
          />
        </v-list-header>
        <ul class="list">
          <v-list-item
            simple
            :key="'defaultContentGender-' + genderContent.key"
            v-for="genderContent in $h.getOrderedGenderArray(currentTemplateSnippet.content.body.default)"
          >
            <v-list-cell :title="$t('gender.' + genderContent.key)" />
            <v-list-cell :value="genderContent.value" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
    <v-row :key="'content-' + locale" v-for="(localeContent, locale) in filteredCurrentTemplateSnippetBody">
      <v-col class="col-12" v-if="locale != 'default'">
        <v-list-header simple>
          <v-list-header-cell
            :title="
              $t('titles.templateSnippetLanguageContent', {
                lang: $t('lang.' + locale),
              })
            "
          />
        </v-list-header>
        <ul class="list">
          <v-list-item
            simple
            :key="'contentGender-' + genderContent.key"
            v-for="genderContent in $h.getOrderedGenderArray(localeContent)"
          >
            <v-list-cell :title="$t('gender.' + genderContent.key)" />
            <v-list-cell :value="genderContent.value" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import templateSnippets from "@/mixins/dropdowns/templateSnippets.js";
import teamAbilities from "@/mixins/teamAbilities.js";

export default {
  name: "TemplateSnippet",
  mixins: [listSettings, templateSnippets, teamAbilities],
  data() {
    return {
      breadcrumbTemplateItems: [
        {
          label: this.$t("menus.templates"),
          route: { name: "Settings", params: { tab: "templates" } },
        },
        {
          label: "",
          route: { name: "Template", params: { uid: "" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.templates"),
        route: { name: "Settings", params: { tab: "templates" } },
      },
    };
  },
  created() {
    this.loadPageData(this.$route.params.template, this.$route.params.uid);
  },
  methods: {
    ...mapActions(["getTemplate", "getTemplateSnippet"]),
    loadPageData(templateUid, uid) {
      const vm = this;
      const p1 = vm.getTemplate({ template: templateUid });
      const p2 = vm.getTemplateSnippet({ template: templateUid, uid: uid });
      Promise.all([p1, p2])
        .then(() => {
          vm.breadcrumbTemplateItems[1].label = vm.currentTemplate.name;
          vm.breadcrumbTemplateItems[1].route = {
            name: "Template",
            params: { uid: vm.currentTemplate.uid },
          };
          vm.breadcrumbTemplateItems.push({
            label: vm.currentTemplateSnippet.name,
            active: true,
          });
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch(() => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    createTemplateSnippet() {
      if (!this.teamCan("template-snippets")) {
        this.$h.showSubscriptionErrorModal(
          this.$modal,
          this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")
        );
      } else {
        this.$goTo("createTemplateSnippet", {
          template: this.currentTemplate.uid,
        });
      }
    },
  },
  computed: {
    filteredCurrentTemplateSnippetSubject() {
      return this.currentTemplateSnippet.content.subject
        ? Object.fromEntries(
            Object.entries(this.currentTemplateSnippet.content.subject).filter(
              ([locale]) =>
                this.$h.templateSnippetsStatus(this.currentTemplateSnippet.status, "type", false) === "email" &&
                locale !== "default"
            )
          )
        : "";
    },
    filteredCurrentTemplateSnippetBody() {
      return Object.fromEntries(
        Object.entries(this.currentTemplateSnippet.content.body).filter((locale) => locale !== "default")
      );
    },
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      currentTemplate: "templates_get_current_template",
      currentTemplateSnippet: "templates_get_current_template_snippet",
    }),
  },
};
</script>
